"use client";

import { c as _c } from "react/compiler-runtime";
import { AlignHorizontalJustifyCenterIcon, AlignHorizontalJustifyEndIcon, AlignHorizontalJustifyStartIcon, AlignHorizontalSpaceAround, AlignHorizontalSpaceBetweenIcon, Maximize2Icon, Minimize2Icon, RectangleHorizontalIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/shadcn/select";
import { BuilderInputField } from "@/ui/yns-components/builder-input-field";
import { CompactButtonGroup } from "@/ui/yns-components/shared/compact-button-group";
import { TEXT_ALIGNMENT_OPTIONS } from "../../shared/form-options";
export const InfoGridForm = t0 => {
  const $ = _c(93);
  const {
    data
  } = t0;
  const context = useStoreBuilderContext();
  const [items, setItems] = useState(data.items);
  let t1;
  if ($[0] !== data.items) {
    t1 = () => {
      setItems(data?.items ?? []);
    };
    $[0] = data.items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = data?.items;
  let t3;
  if ($[2] !== t2) {
    t3 = [t2];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t1, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      value: "space-between",
      icon: <AlignHorizontalSpaceBetweenIcon className="size-3" />,
      tooltip: "Space Between"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      value: "start",
      icon: <AlignHorizontalJustifyStartIcon className="size-3" />,
      tooltip: "Start"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      value: "center",
      icon: <AlignHorizontalJustifyCenterIcon className="size-3" />,
      tooltip: "Center"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [t4, t5, t6, {
      value: "end",
      icon: <AlignHorizontalJustifyEndIcon className="size-3" />,
      tooltip: "End"
    }];
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const justifyContentOptions = t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      value: "constrained",
      icon: <AlignHorizontalSpaceAround className="size-3" />,
      tooltip: "Constrained"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [t8, {
      value: "full",
      icon: <RectangleHorizontalIcon className="size-3" />,
      tooltip: "Full"
    }];
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const imageSizeOptions = t9;
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      value: "outside",
      icon: <Maximize2Icon className="size-3" />,
      tooltip: "Outside"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [t10, {
      value: "inside",
      icon: <Minimize2Icon className="size-3" />,
      tooltip: "Inside"
    }];
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const textPositionOptions = t11;
  let t12;
  if ($[12] !== context || $[13] !== items) {
    t12 = () => {
      const newItems = [...items, {
        title: "",
        description: "",
        image: {
          src: ""
        }
      }];
      setItems(newItems);
      context.saveSelectedPageSectionField({
        fieldPath: "items",
        value: newItems
      });
    };
    $[12] = context;
    $[13] = items;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const addItem = t12;
  let t13;
  if ($[15] !== context || $[16] !== items) {
    t13 = index => {
      if (items.length <= 1) {
        return;
      }
      const newItems_0 = items.filter((_, i) => i !== index);
      setItems(newItems_0);
      context.saveSelectedPageSectionField({
        fieldPath: "items",
        value: newItems_0
      });
    };
    $[15] = context;
    $[16] = items;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const removeItem = t13;
  let T0;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  if ($[18] !== context || $[19] !== data.imageSize || $[20] !== data.justifyContent || $[21] !== data.textAlignment || $[22] !== data.textPosition || $[23] !== data.verticalPadding || $[24] !== items || $[25] !== removeItem) {
    const updateItemField = (index_0, fieldPath, value, t21) => {
      const save = t21 === undefined ? true : t21;
      const newItems_1 = [...items];
      const pathParts = fieldPath.split(".");
      let current = newItems_1[index_0];
      for (let i_0 = 0; i_0 < pathParts.length - 1; i_0++) {
        if (!current) {
          return;
        }
        const cursor = pathParts[i_0];
        if (!cursor) {
          return;
        }
        current = current[cursor];
      }
      current[pathParts[pathParts.length - 1]] = value;
      setItems(newItems_1);
      if (save) {
        context.saveSelectedPageSectionField({
          fieldPath: "items",
          value: newItems_1
        });
      }
    };
    t19 = "space-y-6";
    let t22;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">{"Layout & Display"}</div>;
      $[34] = t22;
    } else {
      t22 = $[34];
    }
    let t23;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <span className="text-xs text-neutral-600 font-medium">Item Distribution</span>;
      $[35] = t23;
    } else {
      t23 = $[35];
    }
    const t24 = data?.justifyContent ?? "space-between";
    let t25;
    if ($[36] !== context) {
      t25 = value_0 => {
        context.saveSelectedPageSectionField({
          fieldPath: "justifyContent",
          value: value_0
        });
      };
      $[36] = context;
      $[37] = t25;
    } else {
      t25 = $[37];
    }
    let t26;
    if ($[38] !== t24 || $[39] !== t25) {
      t26 = <div className="grid gap-1">{t23}<CompactButtonGroup options={justifyContentOptions} defaultValue={t24} onValueChange={t25} className="w-full" /></div>;
      $[38] = t24;
      $[39] = t25;
      $[40] = t26;
    } else {
      t26 = $[40];
    }
    let t27;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t27 = <span className="text-xs text-neutral-600 font-medium">Image Size</span>;
      $[41] = t27;
    } else {
      t27 = $[41];
    }
    const t28 = data?.imageSize ?? "constrained";
    let t29;
    if ($[42] !== context) {
      t29 = value_1 => {
        context.saveSelectedPageSectionField({
          fieldPath: "imageSize",
          value: value_1
        });
      };
      $[42] = context;
      $[43] = t29;
    } else {
      t29 = $[43];
    }
    let t30;
    if ($[44] !== t28 || $[45] !== t29) {
      t30 = <div className="grid gap-1">{t27}<CompactButtonGroup options={imageSizeOptions} defaultValue={t28} onValueChange={t29} className="w-full" /></div>;
      $[44] = t28;
      $[45] = t29;
      $[46] = t30;
    } else {
      t30 = $[46];
    }
    let t31;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t31 = <span className="text-xs text-neutral-600 font-medium">Text Position</span>;
      $[47] = t31;
    } else {
      t31 = $[47];
    }
    const t32 = data?.textPosition ?? "outside";
    let t33;
    if ($[48] !== context) {
      t33 = value_2 => {
        context.saveSelectedPageSectionField({
          fieldPath: "textPosition",
          value: value_2
        });
      };
      $[48] = context;
      $[49] = t33;
    } else {
      t33 = $[49];
    }
    let t34;
    if ($[50] !== t32 || $[51] !== t33) {
      t34 = <div className="grid gap-1">{t31}<CompactButtonGroup options={textPositionOptions} defaultValue={t32} onValueChange={t33} className="w-full" /></div>;
      $[50] = t32;
      $[51] = t33;
      $[52] = t34;
    } else {
      t34 = $[52];
    }
    let t35;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
      t35 = <span className="text-xs text-neutral-600 font-medium">Text Alignment</span>;
      $[53] = t35;
    } else {
      t35 = $[53];
    }
    const t36 = data?.textAlignment ?? "center";
    let t37;
    if ($[54] !== context) {
      t37 = value_3 => {
        context.saveSelectedPageSectionField({
          fieldPath: "textAlignment",
          value: value_3
        });
      };
      $[54] = context;
      $[55] = t37;
    } else {
      t37 = $[55];
    }
    let t38;
    if ($[56] !== t36 || $[57] !== t37) {
      t38 = <div className="grid gap-1">{t35}<CompactButtonGroup options={TEXT_ALIGNMENT_OPTIONS} defaultValue={t36} onValueChange={t37} className="w-full" /></div>;
      $[56] = t36;
      $[57] = t37;
      $[58] = t38;
    } else {
      t38 = $[58];
    }
    let t39;
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
      t39 = <span className="text-xs text-neutral-600 font-medium">Vertical Padding</span>;
      $[59] = t39;
    } else {
      t39 = $[59];
    }
    const t40 = data?.verticalPadding ?? "medium";
    let t41;
    if ($[60] !== context) {
      t41 = value_4 => {
        context.saveSelectedPageSectionField({
          fieldPath: "verticalPadding",
          value: value_4
        });
      };
      $[60] = context;
      $[61] = t41;
    } else {
      t41 = $[61];
    }
    let t42;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
      t42 = <SelectTrigger className="w-full"><SelectValue placeholder="Select padding" /></SelectTrigger>;
      $[62] = t42;
    } else {
      t42 = $[62];
    }
    let t43;
    if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
      t43 = <SelectContent><SelectItem value="none">None</SelectItem><SelectItem value="small">Small</SelectItem><SelectItem value="medium">Medium</SelectItem><SelectItem value="large">Large</SelectItem></SelectContent>;
      $[63] = t43;
    } else {
      t43 = $[63];
    }
    let t44;
    if ($[64] !== t40 || $[65] !== t41) {
      t44 = <div className="grid gap-1">{t39}<Select defaultValue={t40} onValueChange={t41}>{t42}{t43}</Select></div>;
      $[64] = t40;
      $[65] = t41;
      $[66] = t44;
    } else {
      t44 = $[66];
    }
    if ($[67] !== t26 || $[68] !== t30 || $[69] !== t34 || $[70] !== t38 || $[71] !== t44) {
      t20 = <div>{t22}<div className="space-y-2"><div className="grid grid-cols-2 gap-2">{t26}{t30}{t34}{t38}{t44}</div></div></div>;
      $[67] = t26;
      $[68] = t30;
      $[69] = t34;
      $[70] = t38;
      $[71] = t44;
      $[72] = t20;
    } else {
      t20 = $[72];
    }
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">Items</div>;
      $[73] = t18;
    } else {
      t18 = $[73];
    }
    t17 = "space-y-4";
    T0 = Accordion;
    t14 = "multiple";
    t15 = "w-full space-y-3";
    t16 = items.map((item, index_1) => <AccordionItem key={index_1} value={`item-${index_1}`} className="border bg-white group"><AccordionTrigger className="flex items-center bg-neutral-50 p-3 hover:no-underline"><h4 className="text-xs text-neutral-700 font-medium">Item #{index_1 + 1}</h4></AccordionTrigger><AccordionContent><div className="p-4 space-y-4"><BuilderInputField label="Link" placeholder="https://example.com" defaultValue={item.url} onValueChange={value_5 => updateItemField(index_1, "url", value_5)} />{items.length > 1 && <Button variant="outline" size="sm" onClick={() => removeItem(index_1)} className="w-full bg-red-50 border-red-200 text-red-700 hover:bg-red-100 hover:border-red-300">Remove Item</Button>}</div></AccordionContent></AccordionItem>);
    $[18] = context;
    $[19] = data.imageSize;
    $[20] = data.justifyContent;
    $[21] = data.textAlignment;
    $[22] = data.textPosition;
    $[23] = data.verticalPadding;
    $[24] = items;
    $[25] = removeItem;
    $[26] = T0;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    T0 = $[26];
    t14 = $[27];
    t15 = $[28];
    t16 = $[29];
    t17 = $[30];
    t18 = $[31];
    t19 = $[32];
    t20 = $[33];
  }
  let t21;
  if ($[74] !== T0 || $[75] !== t14 || $[76] !== t15 || $[77] !== t16) {
    t21 = <T0 type={t14} className={t15}>{t16}</T0>;
    $[74] = T0;
    $[75] = t14;
    $[76] = t15;
    $[77] = t16;
    $[78] = t21;
  } else {
    t21 = $[78];
  }
  const t22 = items.length >= 4;
  let t23;
  if ($[79] !== addItem || $[80] !== t22) {
    t23 = <Button variant="secondary" className="flex items-center gap-2 w-full" size="sm" onClick={addItem} disabled={t22}>Add New Item</Button>;
    $[79] = addItem;
    $[80] = t22;
    $[81] = t23;
  } else {
    t23 = $[81];
  }
  let t24;
  if ($[82] !== t17 || $[83] !== t21 || $[84] !== t23) {
    t24 = <div className={t17}>{t21}{t23}</div>;
    $[82] = t17;
    $[83] = t21;
    $[84] = t23;
    $[85] = t24;
  } else {
    t24 = $[85];
  }
  let t25;
  if ($[86] !== t18 || $[87] !== t24) {
    t25 = <div>{t18}{t24}</div>;
    $[86] = t18;
    $[87] = t24;
    $[88] = t25;
  } else {
    t25 = $[88];
  }
  let t26;
  if ($[89] !== t19 || $[90] !== t20 || $[91] !== t25) {
    t26 = <div className={t19}>{t20}{t25}</div>;
    $[89] = t19;
    $[90] = t20;
    $[91] = t25;
    $[92] = t26;
  } else {
    t26 = $[92];
  }
  return t26;
};